export const userCamDigit = {};

export const userCamDigitGetters = {
  getUserCamDigit: state => {
    return state.userCamDigit;
  },
  getOnlyUserCamDigit: state => {
    return state.userCamDigit?.user ? state.userCamDigit?.user : null;
  },
};

export const userCamDigitMutations = {
  changeUserCamDigit(state, value) {
    state.userCamDigit = value;
  },
  changeAccessTokenCamDigit(state, value) {
    state.userCamDigit.access_token = value;
  },
  changeNeedComfirmCamDigit(state, value) {
    state.userCamDigit.need_comfirm = value;
  },
};

export const userCamDigitActions = {
  
};
